import { printPDF } from '~core/printPDF';
import { handlePageImageError } from '~core/handlePageImageError';

export const onPrintCanvasBtnClick = async (event) => {
  event.preventDefault();
  await printPDF().catch(handlePageImageError);
};
